export const UrlLink = {
  fastlaneWiki: 'https://icadsistemi.atlassian.net/wiki/spaces/MI/pages/149422115/FastLane',
};
